<template>
  <div id="contenedor-eliminar-contrato-fianza">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Fianza </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la fianza? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarFianza"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixFianzaContrato from './mixFianzaContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarFianzaContrato',
  mixins: [mixFianzaContrato],
  props: {
    contratoFianzaEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
